import { createActions, createReducer } from 'reduxsauce';

const SEARCH_MODE_OPTIONS = {
  NORMAL: 'normal',
  N_PROCESSO: 'nproc',
};

// Types and Creates

// Aqui nos temos por exemplos:
/* 
o array ao lado mapeaia qual parâmtro a função  recebe

exemplo

changeInteiroTeor : ['inteiroTeor']

[Type] => Types.CHANGE_INTEIRO_TEOR(='CHANGE_INTEIRO_TEOR') Constant

[ActionCreator] =>  (receive state return action)

  fn (inteiroTeor [param]) => {
    return {type, new_state(optional)}  (Action)
}

*/

export const { Types, Creators } = createActions({
  changeInteiroTeor: ['inteiroTeor'],
  changeDefaultOperator: ['defaultOperator'],
  changeSynonyms: ['synonyms'],
  changeSearchMode: ['searchMode'],
  setQuery: ['query'],
  setFilterStr: ['filterStr'],
  toggleExpanded: [],
  setTmpFilters: ['key', 'value'],
  saveFilters: ['history', 'match', 'query'],
  justSaveFilters: ['filterStr'],
  loadFilters: [],
  setDefaultFilters: ['defaultFilters'],
  clearFilters: ['permissions'],
  verifyTmpFiltersEntitiesPermission: ['permissions'],
  restoreOptionalFilters: [],
  setOriginalFilters: ['filters'],
  setEntities: ['entities'],
  setExternalFilter: ['filter', 'value'],
  setEntitiesCounter: ['entities_counter'],
  setGeneralCounter: ['general_counter'],
});

const INITIAL_STATE = {
  query: '',
  firstSearch: true,
  expanded: false,
  tmpFilters: {},
  filters: {},
  defaultFilters: {},
  originalFilters: {},
  entities: {},
  appeals: {},
  filterStr: '',
  inteiroTeor: ['ementa', 'full_text'],
  defaultOperator: 'e',
  synonyms: true,
  searchMode: SEARCH_MODE_OPTIONS.NORMAL,
  externalFilters: {
    filter_by_relator: [],
  },
  entities_counter: {},
};

// EXPLANATION: FUNÇÔES QUE ESTARIAM DENTRO DO REDUCER
// reducer handlers
const changeInteiroTeor = (state = INITIAL_STATE, action) => {
  let inteiroTeor;
  if (typeof action.inteiroTeor === 'string') {
    try {
      inteiroTeor = JSON.parse(action.inteiroTeor);
    } catch (e) {
      inteiroTeor = action.inteiroTeor.split(',');
    }
  } else {
    inteiroTeor = action.inteiroTeor;
  }
  return {
    ...state,
    inteiroTeor,
  };
};

const changeDefaultOperator = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    defaultOperator: action.defaultOperator,
  };
};

const changeSynonyms = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    synonyms: action.synonyms,
  };
};

const changeSearchMode = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    searchMode: action.searchMode,
  };
};

const setEntities = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    entities: { ...action.entities },
  };
};

const setQuery = (state = INITIAL_STATE, action) => {
  const searchbar = document.querySelectorAll('#search-bar')[0];
  if (searchbar && searchbar.classList) {
    searchbar.classList.remove('invalid');
  }
  return {
    ...state,
    query: action.query,
  };
};

const setFilterStr = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    filterStr: action.filterStr,
  };
};

const toggleExpanded = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    expanded: !state.expanded,
  };
};

const setTmpFilters = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    tmpFilters: {
      ...state.tmpFilters,
      [action.key]: action.value,
    },
  };
};

const setOriginalFilters = (state = INITIAL_STATE, action) => {
  let originalFilters = {};
  action.filters.forEach((filter) => {
    if (filter.field_name === 'entity') {
      originalFilters.entities = filter;
    } else {
      originalFilters[filter.field_name] = filter;
    }
  });
  return {
    ...state,
    originalFilters,
  };
};

const setDefaultFilters = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    defaultFilters: action.defaultFilters,
  };
};

const loadFilters = (state = INITIAL_STATE, action) => {
  const filters = JSON.parse(localStorage.getItem('filters'));
  let filtersToLoad = {};
  if (filters) {
    filtersToLoad = { ...filters };
  }
  Object.keys(state.defaultFilters).forEach((key) => {
    if (!filtersToLoad[key]) {
      filtersToLoad[key] = state.defaultFilters[key];
    }
  });
  return {
    ...state,
    filters: { ...filtersToLoad },
    tmpFilters: { ...filtersToLoad },
  };
};

const restoreOptionalFilters = (state = INITIAL_STATE, action) => {
  let newFilters = {};
  Object.keys(state.defaultFilters).forEach((key) => {
    if (!newFilters[key] && !(key === 'entity' || key === 'entities')) {
      newFilters[key] = state.defaultFilters[key];
    }
  });
  newFilters = {
    ...state.filters,
    ...newFilters,
  };
  localStorage.setItem('filters', JSON.stringify(newFilters));
  return {
    ...state,
    filters: { ...newFilters },
    tmpFilters: { ...newFilters },
    filterStr: buildFilterUrl(newFilters),
    entities_counter: {},
    inteiroTeor: ['ementa', 'full_text'],
    defaultOperator: 'e',
    synonyms: true,
    searchMode: SEARCH_MODE_OPTIONS.NORMAL,
  };
};

const clearFilters = (state = INITIAL_STATE, action) => {
  let newFilters = {};
  Object.keys(state.defaultFilters).forEach((key) => {
    if (!newFilters[key]) {
      newFilters[key] = state.defaultFilters[key];
    }
  });
  return {
    ...state,
    filters: { ...newFilters },
    tmpFilters: { ...newFilters },
    inteiroTeor: ['ementa', 'full_text'],
    defaultOperator: 'e',
    synonyms: true,
    searchMode: SEARCH_MODE_OPTIONS.NORMAL,
  };
};

const buildFilterUrl = (reduxFilters) => {
  const filters = {};
  Object.keys(reduxFilters).forEach((filterKey) => {
    if (filterKey === 'entities') {
      filters.entity = reduxFilters[filterKey]?.map((rFilter) =>
        typeof rFilter === 'object' ? rFilter.id : rFilter,
      );
    } else {
      if (reduxFilters[filterKey]) {
        filters[filterKey] =
          typeof reduxFilters[filterKey] === 'object'
            ? Array.isArray(reduxFilters[filterKey])
              ? reduxFilters[filterKey]?.map((rFilter) =>
                  typeof rFilter === 'object' ? rFilter.id : rFilter,
                )
              : reduxFilters[filterKey]
            : parseInt(reduxFilters[filterKey]);
      }
    }
  });
  return JSON.stringify(filters);
};

const justSaveFilters = (state = INITIAL_STATE, action) => {
  let filters = {
    ...JSON.parse(action.filterStr),
    entities: JSON.parse(action.filterStr).entity,
  };

  delete filters.entity;

  localStorage.setItem('filters', JSON.stringify(filters));
  return {
    ...state,
    filters: {
      ...filters,
    },
    tmpFilters: {
      ...filters,
    },
    filterStr: buildFilterUrl(filters),
  };
};

const saveFilters = (state = INITIAL_STATE, action) => {
  // TODO: AQUI é saveFilters que faz alteração do estado dos filtros
  const a = JSON.parse(localStorage.getItem('filters'));

  const filtersString = buildFilterUrl({
    ...state.tmpFilters,
    date_range: {
      0: a.date_range[0],
      1: a.date_range[1],
    },
    filter_by_vote: a.filter_by_vote,
    filter_by_secao_carf: a.filter_by_secao_carf,
    filter_by_favorability: a.filter_by_favorability,
    precedente_qualificado: a?.precedente_qualificado,
  });

  if (action.history) {
    setTimeout(() => {
      const inteiroTeor = state.inteiroTeor
        ? typeof state.inteiroTeor === 'string'
          ? state.inteiroTeor
          : JSON.stringify(state.inteiroTeor)
        : null;
      const defaultOperator = state.defaultOperator;
      const synonyms = state.synonyms;
      const searchMode = state.searchMode;

      if (action.query) {
        const urlString = `/pesquisa/resultados?query=${action.query}${
          inteiroTeor ? `&fields=${inteiroTeor}` : ''
        }${defaultOperator ? `&default_operator=${defaultOperator}` : ''}${
          synonyms !== null ? `&synonyms=${synonyms}` : ''
        }${searchMode ? `&search_mode=${searchMode}` : `&search_mode=${SEARCH_MODE_OPTIONS.NORMAL}`}${
          filtersString !== '' && filtersString
            ? `&filters=${filtersString}`
            : ''
        }`;
        action.history.push(urlString);
        localStorage.setItem('lastSearch', urlString);
      } else {
        // O que esse caso faz ?
        const urlString = `/pesquisa/resultados?query=${state.query}${
          inteiroTeor ? `&fields=${inteiroTeor}` : ''
        }${defaultOperator ? `&default_operator=${defaultOperator}` : ''}${
          synonyms !== null ? `&synonyms=${synonyms}` : ''
        }${searchMode ? `&search_mode=${searchMode}` : `&search_mode=${SEARCH_MODE_OPTIONS.NORMAL}`}${
          filtersString !== '' && filtersString
            ? `&filters=${filtersString}`
            : ''
        }`;
        action.history.push(urlString);
        localStorage.setItem('lastSearch', urlString);
      }
    }, 100);
  }

  return {
    ...state,
    filters: {
      ...state.tmpFilters,
    },
    filterStr: filtersString,
  };
};

const setExternalFilter = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    externalFilters: {
      ...state.externalFilters,
      [action.filter]: action.value,
    },
  };
};

const setEntitiesCounter = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    entities_counter: {
      ...action.entities_counter,
    },
  };
};

const setGeneralCounter = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    general_counter: {
      ...action.general_counter,
    },
  };
};

const verifyTmpFiltersEntitiesPermission = (state = INITIAL_STATE, action) => {
  let { tmpFilters } = state;

  return {
    ...state,
    tmpFilters,
  };
};

// Mapeando REDUCER de acordo com o tipo de action
// Cada reduce handler é mapeado para um tipo de action (para responder a ela)
// As Actions são criadas usando shortcut do redux-sauce
// Usamos o padrão ducks
export default createReducer(INITIAL_STATE, {
  [Types.CHANGE_INTEIRO_TEOR]: changeInteiroTeor,
  [Types.CHANGE_DEFAULT_OPERATOR]: changeDefaultOperator,
  [Types.CHANGE_SYNONYMS]: changeSynonyms,

  [Types.CHANGE_SEARCH_MODE]: changeSearchMode,

  [Types.SET_QUERY]: setQuery,
  [Types.SET_GENERAL_COUNTER]: setGeneralCounter,

  [Types.SET_FILTER_STR]: setFilterStr,
  [Types.TOGGLE_EXPANDED]: toggleExpanded,
  [Types.SET_TMP_FILTERS]: setTmpFilters,
  [Types.SAVE_FILTERS]: saveFilters,
  [Types.JUST_SAVE_FILTERS]: justSaveFilters,
  [Types.LOAD_FILTERS]: loadFilters,
  [Types.SET_DEFAULT_FILTERS]: setDefaultFilters,
  [Types.SET_ORIGINAL_FILTERS]: setOriginalFilters,
  [Types.CLEAR_FILTERS]: clearFilters,
  [Types.RESTORE_OPTIONAL_FILTERS]: restoreOptionalFilters,
  [Types.SET_ENTITIES]: setEntities,
  [Types.SET_EXTERNAL_FILTER]: setExternalFilter,
  [Types.SET_ENTITIES_COUNTER]: setEntitiesCounter,
  [Types.VERIFY_TMP_FILTERS_ENTITIES_PERMISSION]:
    verifyTmpFiltersEntitiesPermission,
});
